<template>
  <div class="content">
    <van-nav-bar
      :style="{ background: sessionStorage.colorCode }"
      class="flexNone"
      left-arrow
      fixed
      @click-left="
        $router.push(
          '/' +
            sessionStorage.storeId +
            '/' +
            sessionStorage.placeId +
            '/' +
            sessionStorage.code
        )
      "
    >
      <template #title>
        <van-dropdown-menu>
          <van-dropdown-item
            v-model="locale"
            :options="locale_option"
            @change="localeChange"
          />
        </van-dropdown-menu>
      </template>
    </van-nav-bar>
    <main>
      <div class="header">
        <div class="seat">
          {{ $t("Home.seat") }}{{ sessionStorage.placeId }}
        </div>
        <div class="dishDetail">
          <van-button icon="orders-o" size="small" type="info">
            {{ $t("Dishes.orderDetail") }}
          </van-button>
        </div>
      </div>
      <div class="swipe_content">
        <van-swipe
          class="my-swipe"
          :autoplay="3000"
          indicator-color="white"
          :width="'100%'"
        >
          <van-swipe-item v-for="image in images" :key="image">
            <van-image width="100%" height="180px" fit="fill" :src="image" />
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="menu_content">
        <div class="menu_nav_title">菜品分类</div>
        <div class="menu_nav">
          <div
            class="menu_nav_cell"
            :style="
              activeKey == index
                ? { background: sessionStorage.colorCode, color: '#fff' }
                : {}
            "
            v-for="(item, index) in dishes"
            :key="index"
            @click="changeActMenus(index)"
          >
            {{ item.name }}
          </div>
        </div>
        <div class="menu_nav_title" v-if="isAll">{{ actMenus_name }}菜品</div>
        <div class="dishes_list">
          <div
            class="dishes_card"
            v-for="(item, num) in actMenus"
            :key="num"
            @click.stop="toDetails(item)"
          >
            <van-image
              v-if="item"
              width="100%"
              height="150px"
              fit="fill"
              :src="item.image ? item.image.path : ''"
            />
            <div class="card_content">
              <div class="name">{{ item.name }}</div>
              <div class="card_footer">
                <span class="price"
                  >{{ sessionStorage.getItem("currency")
                  }}{{ item.original_price }}
                </span>
                <van-button
                  class="addCartBtn"
                  round
                  size="mini"
                  :color="sessionStorage.colorCode"
                  icon="plus"
                  @click.stop="addDish(item.id, index, 1)"
                ></van-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
    <footer>
      <!-- 底部固定购物车信息 -->
      <van-tabbar class="cart_tabbar" :fixed="true">
        <div class="cart_content">
          <div class="cart_left" @click="cartShow = true">
            <van-badge :content="shopCart.count">
              <svg-icon
                :style="{
                  width: '34px',
                  height: '34px',
                  filter: `drop-shadow(${sessionStorage.colorCode} 100px 0)`,
                  transform: 'translateX(-100px)'
                }"
                iconClass="cart"
                class="icon"
              />
            </van-badge>
          </div>
          <div class="cart_right">
            <div
              class="fl total_price"
              :style="{ color: sessionStorage.colorCode }"
            >
              {{ sessionStorage.getItem("currency") }}{{ shopCart.total }}
            </div>
            <!-- 下单按钮 -->
            <van-button
              :color="sessionStorage.colorCode"
              class="cart_right_btn"
              round
              @click="cook()"
            >
              OK
            </van-button>
          </div>
        </div>
      </van-tabbar>
    </footer>
    <!-- 购物车详情 -->
    <van-popup v-model="cartShow" position="bottom" :style="{ height: '60%' }">
      <van-cell-group class="cartHeader">
        <van-cell>
          <div
            style="font-size: 18px; font-weight: 600; color: #000"
            slot="title"
          >
            <van-icon
              slot="left-icon"
              name="./static/img/toback.png"
              size="16px"
              @click="cartShow = false"
            />
            <!-- {{ $t("Dishes.cart") }} -->
            {{ $t("Dishes.myCart") }}[ {{ shopCart.count }} ]
          </div>
          <van-icon
            slot="right-icon"
            name="./static/img/empty.png"
            size="26px"
            @click="chearShopcart"
          />
        </van-cell>
      </van-cell-group>
      <div class="cartDetail" v-if="shopCart.data">
        <template v-for="(dish, index) in shopCart.data">
          <div class="cartItem" :key="index">
            <!-- 产品 -->
            <div class="cart_dish">
              <div class="dish noExceed">
                <template v-if="dish.image">
                  <van-image
                    class="menuImg"
                    width="70"
                    height="70"
                    :src="dish.image.path"
                  />
                </template>
                <template v-else>
                  <van-image
                    class="menuImg"
                    width="70"
                    height="70"
                    :src="sessionStorage.images"
                  />
                </template>
                <div style="margin-left: 10px; width: calc(100% - 80px);">
                  <div class="menu_name">{{ dish.menu_name }}</div>
                  <div class="cart_dish_des noExceed">
                    <template
                      v-if="dish.menus_name.length == 0 && dish.tags_name"
                    >
                      <span
                        v-for="(tagName, index) in dish.tags_name"
                        :key="index"
                      >
                        {{ tagName }}
                        <span v-if="dish.tags_name.length != index + 1">
                          +
                        </span>
                      </span>
                    </template>
                    <span
                      v-if="dish.menus_name.length == 0 && dish.remark[0] != ''"
                      >{{ $t("PackageDetail.remark") }}：</span
                    >
                    <template
                      v-if="dish.menus_name.length == 0 && dish.remark[0] != ''"
                    >
                      ({{ dish.remark[0] }})
                    </template>
                  </div>
                  <div
                    style="display: flex; align-items: center; justify-content: space-between;"
                  >
                    <div class="realPrice">
                      {{ sessionStorage.getItem("currency") }}{{ dish.price }}
                    </div>
                    <!-- 加减和价格 -->
                    <div class="icon_group">
                      <div class="cart_dish_icon fl">
                        <van-icon
                          class="reduceBtn"
                          :style="{
                            border: `1px solid ${sessionStorage.colorCode}`
                          }"
                          name="./static/img/reduce.png"
                          size="10px"
                          @click="subShopCart(dish.id, dish.number)"
                        ></van-icon>
                        <span
                          style="
                              display: inline-block;
                              min-width: 30px;
                              height: 30px;
                              text-align: center;
                              line-height: 30px;
                              vertical-align: top;
                            "
                        >
                          {{ dish.number }}
                        </span>
                        <van-icon
                          class="addBtn"
                          :style="{ background: sessionStorage.colorCode }"
                          name="./static/img/add.png"
                          size="12px"
                          @click="addShopCart(dish.id)"
                        ></van-icon>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 套餐 -->
              <div v-if="dish.menus_name">
                <div
                  class="cart_dish son_dish"
                  v-for="(menu, key) in dish.menus_name"
                  :key="key"
                >
                  <div
                    v-if="typeof menu == 'object'"
                    class="cart_dish_name noExceed fl"
                  >
                    <template v-for="(menuArr, i) in menu">
                      {{ menuArr }}{{ i == menu.length - 1 ? "" : "、" }}
                    </template>
                  </div>
                  <div v-else class="cart_dish_name noExceed fl">
                    {{ menu }}
                  </div>

                  <div
                    v-if="typeof menu == 'object'"
                    class="cart_dish_price noExceed fl"
                  >
                    {{ sessionStorage.getItem("currency") }}
                    <template v-for="(priceArr, j) in dish.fill_price[key]">
                      {{ j == 0 ? priceTotal(dish.fill_price[key]) : "" }}
                    </template>
                  </div>
                  <div v-else class="cart_dish_price noExceed fl">
                    {{ sessionStorage.getItem("currency")
                    }}{{ dish.fill_price[key] }}
                  </div>
                  <div class="cart_dish_des noExceed fl">
                    <template v-if="dish.tags_name[key]">
                      <template v-if="typeof dish.tags_name[key] == 'object'">
                        <template v-for="(tagName, i) in dish.tags_name[key]">
                          <template v-if="typeof tagName == 'object'">
                            {{ arrShow(tagName) }}
                          </template>
                          <template v-else>
                            {{ tagName }}
                          </template>
                          <template v-if="dish.remark[key][i]">
                            ({{ dish.remark[key][i]
                            }}{{
                              i == dish.remark[key].length - 1 ||
                              !dish.remark[key][i]
                                ? ""
                                : ""
                            }})
                          </template>
                          &nbsp;&nbsp;
                        </template>
                      </template>
                      <template v-else>
                        {{ dish.tags_name[key] }}
                        <template v-if="dish.remark[key]">
                          ({{ dish.remark[key] }})
                        </template>
                      </template>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <div style="height: 50px;"></div>
      </div>
      <van-tabbar class="cart_tabbar" :fixed="true">
        <div class="cart_content">
          <div class="cart_left" @click="cartShow = true">
            <van-badge :content="shopCart.count">
              <svg-icon
                :style="{
                  width: '34px',
                  height: '34px',
                  filter: `drop-shadow(${sessionStorage.colorCode} 100px 0)`,
                  transform: 'translateX(-100px)'
                }"
                iconClass="cart"
                class="icon"
              />
            </van-badge>
          </div>
          <div class="cart_right">
            <div
              class="fl total_price"
              :style="{ color: sessionStorage.colorCode }"
            >
              {{ sessionStorage.getItem("currency") }}{{ shopCart.total }}
            </div>
            <!-- 下单按钮 -->
            <van-button
              :color="sessionStorage.colorCode"
              class="cart_right_btn"
              round
              @click="cook()"
            >
              OK
            </van-button>
          </div>
        </div>
      </van-tabbar>
    </van-popup>
    <!-- 菜品详情 -->
    <van-popup
      v-model="detailShow"
      position="bottom"
      :style="{ height: '75%' }"
    >
      <div class="detailBox" v-if="dishesDetail">
        <div class="detail_image">
          <van-image
            v-if="dishesDetail.image"
            width="100%"
            height="200px"
            fit="fill"
            :src="dishesDetail.image ? dishesDetail.image.path : ''"
          />
          <p class="dishes_name">{{ dishesDetail.name }}</p>
          <van-button
            round
            class="closeBtn"
            size="small"
            color="#fff"
            icon="cross"
            @click="detailShow = false"
          ></van-button>
        </div>
        <div class="detail_content van-hairline--bottom hairline">
          <span class="price margin_left">
            {{ sessionStorage.getItem("currency")
            }}{{ dishesDetail.original_price }}
          </span>
          <p class="name_en margin_left van-multi-ellipsis--l2">
            {{ dishesDetail.name_en }}
          </p>
        </div>
        <div class="detail_tags van-hairline--bottom hairline">
          <div
            class="tags"
            v-for="(item, index) in dishesDetail.perfer.data"
            :key="index"
          >
            <h4>{{ item.name }}</h4>
            <template v-if="dishesDetail.perfer.data[index].is_choiced == 1">
              <span
                class="tag is_choiced"
                :style="
                  perferResult[index][num] == tag.id
                    ? {
                        borderColor: sessionStorage.colorCode,
                        background: sessionStorage.colorCode,
                        color: '#fff'
                      }
                    : {}
                "
                v-for="(tag, num) in item.category.data"
                :key="num"
                @click="changeResult(index, num, tag.id)"
              >
                {{ tag.name }}
              </span>
            </template>
            <template v-else>
              <span
                class="tag"
                :style="
                  perferResult[index][0] == tag.id
                    ? {
                        borderColor: sessionStorage.colorCode,
                        background: sessionStorage.colorCode,
                        color: '#fff'
                      }
                    : {}
                "
                v-for="(tag, num) in item.category.data"
                :key="num"
                @click="changeResult(index, num, tag.id)"
              >
                {{ tag.name }}
              </span>
            </template>
          </div>
        </div>
        <div class="remarkbox van-hairline--bottom hairline">
          <h4>备注</h4>
          <van-field
            class="remark"
            v-model="remark"
            rows="2"
            autosize
            type="textarea"
            placeholder="有什么特殊要求请告诉我们..."
            show-word-limit
          />
        </div>
        <div class="detail_footer">
          <van-stepper v-model="number" />
          <van-button
            class="addCartBtn"
            size="small"
            :color="sessionStorage.colorCode"
            icon="cart-o"
            @click="addCart"
          >
            加入购物
          </van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      locale: 1,
      locale_option: [
        { text: "简体中文", value: 0 },
        { text: "繁体中文", value: 1 },
        { text: "English", value: 2 }
      ],
      images: [],
      dishes: [],
      actMenus_name: "",
      activeKey: 0,
      actMenus: [],
      active: 0,
      isAll: false,
      shopCart: [],
      cartShow: false,
      detailShow: false,
      number: 1,
      dishesDetail: {
        name: "",
        image: "",
        perfer: {
          data: {}
        }
      },
      remark: "",
      perferResult: []
    };
  },
  mounted() {
    this.getShopInfo();
    this.getDishes();
    this.getShopCart();
  },
  methods: {
    // 语言选择
    localeChange(value) {
      this.locale = value;
      this.$i18n.locale =
        this.value1 == 0 ? "zh" : this.value1 == 1 ? "hk" : "en";
      sessionStorage.setItem("locale", locale);
    },
    // 选择菜品分类
    changeActMenus(index) {
      this.activeKey = index;
      this.actMenus = this.dishes[this.activeKey].menus;
      this.actMenus_name = this.dishes[this.activeKey].name;
    },
    //获取店铺信息
    getShopInfo() {
      this.$axios({
        method: "get",
        headers: {
          code: this.$route.params.code
        },
        url:
          this.$build + "/api/store/" + sessionStorage.storeId + "/customerShow"
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            res.data.data.banner.forEach(item => {
              this.images.push(item.path);
            });
          } else {
            this.$toast.allowMultiple();
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          console.log(err);
          this.$toast({
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    // 获取 菜品列表——全部 —— 计算数量
    getDishes() {
      this.$axios({
        method: "get",
        headers: {
          type: sessionStorage.type,
          code: sessionStorage.code,
          placeid: sessionStorage.placeId
        },
        url:
          this.$build +
          "/api/store/" +
          sessionStorage.storeId +
          "/customerMenus/in/" +
          sessionStorage.placeId
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            let dishes = [];
            res.data.data.forEach(item => {
              if (item.status == 1) {
                dishes.push(item);
              }
            });
            this.dishes = dishes;
            this.actMenus = this.dishes[this.activeKey].menus;
            this.actMenus_name = this.dishes[this.activeKey].name;
            // console.log(this.actMenus);
            this.isAll = true;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                duration: 1000,
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          console.log(err);
          this.$toast({
            duration: 1000,
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    // 获取购物车
    getShopCart() {
      this.$axios({
        method: "get",
        headers: {
          type: sessionStorage.type,
          code: sessionStorage.code,
          placeid: sessionStorage.placeId
        },
        url:
          this.$build +
          "/api/place/" +
          sessionStorage.placeId +
          "/customerShopcart"
      })
        .then(res => {
          // console.log(res);
          if (res.data.status == 200) {
            this.shopCart = res.data;
            this.shopCart.data.forEach(item => {
              let arr = [];
              if (item.menus_name.length != 0 && item.tags_name) {
                // 套餐偏好重新排版
                item.tags_name.forEach((i, num) => {
                  i.forEach((j, index) => {
                    let list = []; //临时存储
                    if (i.length > 1) {
                      list.push(`(${item.menus_name[num][index]})：`);
                    }
                    if (typeof j == "object") {
                      j.forEach(tag => {
                        list.push(tag);
                      });
                    } else {
                      list.push(j);
                    }
                    i.splice(index, 1, list);
                  });
                });
              } else if (item.menus_name.length == 0 && item.tags_name) {
                // 单品偏好重新排版
                if (item.tags_name[0] != "") {
                  item.tags_name.forEach(i => {
                    i.forEach(j => {
                      if (typeof j == "object") {
                        j.forEach(tag => {
                          arr.push(tag);
                        });
                      } else {
                        arr.push(j);
                      }
                    });
                  });
                }
                item.tags_name = arr;
              }
            });
          } else {
            // for (var item in res.data.error) {
            //     this.$toast({
            //         duration:2000,
            //         type:'fail',
            //         message:res.data.error[item],
            //     });
            // }
          }
        })
        .catch(err => {
          console.log(err);
          this.$toast({
            duration: 1000,
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    // 打开菜品详情
    toDetails(item) {
      this.$axios({
        method: "get",
        headers: {
          type: sessionStorage.type,
          code: sessionStorage.code,
          placeid: sessionStorage.placeId
        },
        url: this.$build + `/api/menu/${item.id}/customerIndex`
      }).then(res => {
        console.log(res);
        if (res.data.status == 200) {
          this.detailShow = true;
          this.number = 1;
          this.dishesDetail = res.data.data;
          for (var i = 0; i < this.dishesDetail.perfer.data.length; i++) {
            if (this.dishesDetail.perfer.data[i].category.data.length > 0) {
              this.perferResult[i] = [];
              this.perferResult[i].push(
                this.dishesDetail.perfer.data[i].category.data[0].id
              );
              // console.log(this.perferResult);
            }
          }
        } else {
          for (var item in res.data.error) {
            this.$toast({
              duration: 1000,
              type: "fail",
              message: res.data.error[item]
            });
          }
        }
      });
    },
    selectTag(tag, index) {
      let num = this.perferIds[index].indexOf(tag.id) || -1;
      if (num == -1) {
        this.perferIds[index].push(tag.id);
      } else {
        this.perferIds[index].splice(num, 1);
      }
      console.log(this.perferIds);
    },
    // 判断数组的值是否全为空
    areAllValuesEmpty(array) {
      return array.every(
        value =>
          value === null ||
          value === undefined ||
          value === "" ||
          value === 0 ||
          value === false
      );
    },
    // 选择偏好标签
    changeResult(index, key, id) {
      // console.log(index, key, id);
      if (this.dishesDetail.perfer.data[index].is_choiced == 1) {
        let arr = JSON.parse(JSON.stringify(this.perferResult[index]));
        let type = arr.indexOf(id);
        type == -1 ? (arr[key] = id) : arr.splice(type, 1, "");
        if (!this.areAllValuesEmpty(arr)) {
          this.$set(this.perferResult, index, arr);
        }
      } else {
        let arr = this.perferResult[index];
        arr[0] = id;
        this.$set(this.perferResult, index, arr);
      }
    },
    // 菜品-详情 加入购物
    addCart() {
      var perferIds = [];
      let arr = [];
      this.perferResult.forEach((item, i) => {
        if (item.length == 1) {
          arr[i] = item[0];
        } else {
          arr[i] = JSON.parse(JSON.stringify(item));
          arr[i].forEach((j, num) => {
            if (j == "" || j == null) {
              arr[i].splice(num, 1);
            }
          });
        }
      });
      this.$axios({
        method: "post",
        headers: {
          type: sessionStorage.type,
          code: sessionStorage.code,
          placeid: sessionStorage.placeId
          // floatkey: sessionStorage.floatkey
        },
        url: this.$build + "/api/shopcart/customerStore",
        data: {
          place_id: sessionStorage.placeId,
          menu_id: this.$route.params.id,
          tags_id: JSON.stringify(perferIds),
          remark: JSON.stringify(this.remark)
        }
      })
        .then(res => {
          // console.log(res);
          if (res.data.status == 200) {
            this.$toast({
              type: "success",
              message: "加入到购物车"
            });
            // this.addAnimation();
            // this.musicPlayer.currentTime = 0;
            // this.musicPlayer.play();
            this.getShopCart();
          } else {
            this.$toast.allowMultiple();
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          console.log(err);
          this.$toast({
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    // 修改购物车菜品数量
    addShopCart(id) {
      this.$axios({
        method: "PATCH",
        headers: {
          type: sessionStorage.type,
          code: sessionStorage.code,
          placeid: sessionStorage.placeId
        },
        url: this.$build + "/api/shopcart/" + id + "/customerUpdate",
        data: {
          type: "add"
        }
      })
        .then(res => {
          // console.log(res);
          if (res.data.status == 200) {
            this.getShopCart();
          } else {
            this.$toast.allowMultiple();
            for (var item in res.data.error) {
              this.$toast({
                duration: 1000,
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            duration: 1000,
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    subShopCart(id, number) {
      if (number == 1) {
        this.$dialog
          .confirm({
            title: this.$t("Dishes.del"),
            message: this.$t("Dishes.isDel"),
            confirmButtonColor: "#2f75f4",
            confirmButtonText: this.$t("vantText.confirm"),
            cancelButtonText: this.$t("vantText.cancel")
          })
          .then(() => {
            this.$axios({
              method: "PATCH",
              headers: {
                type: sessionStorage.type,
                code: sessionStorage.code,
                placeid: sessionStorage.placeId
              },
              url: this.$build + "/api/shopcart/" + id + "/customerUpdate",
              data: {
                type: "reduce"
              }
            })
              .then(res => {
                // console.log(res);
                if (res.data.status == 200) {
                  this.getShopCart();
                  this.getDishes();
                  if (this.shopCart.data.length === 1) {
                    this.isShopCartShow = false;
                    this.shopCart = {};
                  }
                } else {
                  this.$toast.allowMultiple();
                  for (var item in res.data.error) {
                    this.$toast({
                      duration: 1000,
                      type: "fail",
                      message: res.data.error[item]
                    });
                  }
                }
              })
              .catch(err => {
                console.log(err);
                this.$toast({
                  duration: 1000,
                  type: "fail",
                  message: this.$t("common.message")
                });
              });
          })
          .catch(() => {});
      } else {
        this.$axios({
          method: "PATCH",
          headers: {
            type: sessionStorage.type,
            code: sessionStorage.code,
            placeid: sessionStorage.placeId
          },
          url: this.$build + "/api/shopcart/" + id + "/customerUpdate",
          data: {
            type: "reduce"
          }
        })
          .then(res => {
            // console.log(res);
            if (res.data.status == 200) {
              this.getShopCart();
              this.getDishes();
            } else {
              this.$toast.allowMultiple();
              for (var item in res.data.error) {
                this.$toast({
                  duration: 1000,
                  type: "fail",
                  message: res.data.error[item]
                });
              }
            }
          })
          .catch(err => {
            console.log(err);
            this.$toast({
              duration: 1000,
              type: "fail",
              message: this.$t("common.message")
            });
          });
      }
    },
    addDish(id, index, number) {
      this.$axios({
        method: "POST",
        headers: {
          type: sessionStorage.type,
          code: sessionStorage.code,
          placeid: sessionStorage.placeId
          // floatkey: sessionStorage.floatkey
        },
        url: this.$build + "/api/shopcart/customerCreated",
        data: {
          place_id: sessionStorage.placeId,
          menu_id: id,
          number
        }
      })
        .then(res => {
          if (res.data.status == 200) {
            this.getShopCart();
            this.actMenus[index].count = this.actMenus[index].count;
            this.$toast({
              type: "success",
              message: res.data.message.replace(" ", "  \n"),
              duration: 1000
            });
          } else {
            this.$toast.allowMultiple();
            for (var item in res.data.error) {
              this.$toast({
                duration: 1000,
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          console.log(err);
          // this.$toast({
          //   duration: 1000,
          //   type: "fail",
          //   message: this.$t("common.message")
          // });
        });
    },
    // 清空购物车
    chearShopcart() {
      this.$axios({
        method: "DELETE",
        headers: {
          type: sessionStorage.type,
          code: sessionStorage.code,
          placeid: sessionStorage.placeId
        },
        url: this.$build + "/api/shopcart/customerClear"
      })
        .then(res => {
          if (res.data.status == 200) {
            this.getShopCart();
            this.getDishes();
            this.$toast({
              type: "success",
              message: res.data.message,
              duration: 1000
            });
          } else {
            this.$toast.allowMultiple();
          }
        })
        .catch(err => {
          this.$toast({
            duration: 1000,
            type: "fail",
            message: this.$t("common.message")
          });
        });
    }
  }
};
</script>

<style scoped>
/deep/ .van-nav-bar .van-icon {
  font-size: 26px;
  color: #fff;
}
/deep/ .van-sidebar {
  width: 25%;
  height: calc(100% - 3.125rem);
  padding-bottom: 3.125rem;
  background-color: #bbbbbb;
  float: left;
  overflow: auto;
  position: relative;
}
/deep/ .van-sidebar-item {
  text-align: center;
  padding: 10px 10px 10px 8px;
  background-color: #fff;
  border-bottom: 1px solid #eee;
  margin: 15px 10px 15px 0px;
  border-radius: 0px 50px 50px 0px;
}
/deep/.van-sidebar-item--select::before {
  background: none;
}
/deep/ .van-sidebar-item--select {
  color: #fff;
  border-color: #000;
  background-color: #000;
}
/deep/ .van-dropdown-menu__bar {
  width: 120px;
  height: auto;
  background: none;
}
/deep/ .van-dropdown-menu__title {
  color: #fff;
}
/deep/ .van-dropdown-menu__title::after {
  right: -14px;
  margin-top: -10px;
  border: 6px solid;
  border-color: transparent transparent #ffffff #ffffff;
  opacity: 0.7;
}
/deep/ .van-dropdown-menu__title--down::after {
  margin-top: -2px;
}
/deep/ .van-button--small {
  font-size: 14px;
}
/deep/ .van-button--mini {
  font-size: 12px;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 15px;
  height: 50px;
}
.content {
  margin-top: 2.875rem;
  height: calc(100vh - 2.875rem);
  overflow: auto;
}
.seat {
  font-size: 18px;
  font-weight: 600;
}
.my-swipe .van-swipe-item {
  color: #000;
  font-size: 20px;
  text-align: center;
}
.menu_nav_title {
  font-size: 18px;
  font-weight: 600;
  padding: 0px 15px;
}
.menu_nav {
  display: flex;
  flex-wrap: wrap;
  justify-content: left;
}
.menu_nav_cell {
  width: 30%;
  padding: 10px 0px;
  margin: 10px 5px;
  border-radius: 20px;
  text-align: center;
  border: 1px solid #ccc;
  box-sizing: border-box;
  background: #fff;
}
.dishes_list {
  display: flex;
  flex-wrap: wrap;
  justify-content: start;
  padding: 0px 1%;
  padding-bottom: 6.125rem;
}
.dishes_card {
  width: 48%;
  margin: 1%;
  box-sizing: border-box;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 0 10px #979797;
}
.name,
.card_footer {
  margin: 5px 10px;
  font-size: 14px;
  font-family: Inter, system-ui, sans-serif;
}
.name {
  font-weight: 700;
}
.price {
  color: #fc0606;
  font-weight: 700;
}
.card_footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 0px 10px;
}
.cart_tabbar {
  background: #fff;
  box-shadow: 0px 0px 10px #979797;
  padding: 0px 0px 10px;
}
.cart_content {
  width: 88%;
  height: 45px;
  padding: 10px 0px 0px;
  margin: 8px auto;
  overflow: hidden;
}
.cart_left {
  width: 60%;
  height: 34px;
  line-height: 34px;
  float: left;
}
.memberBtn {
  position: absolute;
  width: 90%;
  bottom: 5%;
  left: 5%;
}
.cart_right {
  width: 30%;
  height: 34px;
  line-height: 26px;
  float: right;
  text-align: right;
  display: flex;
  justify-content: right;
}
.cart_right_btn {
  height: 34px;
  line-height: 34px;
  font-size: 16px;
  color: #222;
  padding: 5px 35px;
  font-weight: 600;
  font-size: 18px;
}
.total_price {
  height: 34px;
  line-height: 34px;
  text-indent: 10px;
  font-size: 20px;
  font-weight: 600;
  text-align: right;
  margin-right: 10px;
}
.detailBox {
  padding: 0px 0px 20px;
}
.detail_image {
  position: relative;
}
.dishes_name {
  color: #fff;
  font-weight: 600;
  position: absolute;
  bottom: 5px;
  left: 10px;
}
.detail_content {
  padding: 0px 10px 10px;
}
.detail_content .price {
  font-size: 20px;
  font-weight: 700;
}
.name_en {
  margin: 5px 0px;
  font-size: 14px;
  color: #999;
}
h4 {
  font-size: 18px;
  margin: 10px 10px 5px;
}
.tag {
  display: inline-block;
  background: #fff;
  border: 1px solid #ccc;
  color: #000;
  font-size: 14px;
  border-radius: 20px;
  padding: 10px 20px;
  margin: 5px 5px;
}
.detail_tags {
  max-height: 190px;
  overflow-y: scroll;
  padding: 0px 0px 10px;
  margin: 0px 0px 10px;
}
.detail_footer {
  position: fixed;
  bottom: 0px;
  width: calc(100vw - 20px);
  height: 50px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  margin: 0px 10px;
}
.addCartBtn {
  border-radius: 10px;
}
.remark {
  border: 1px solid #ccc;
  border-radius: 10px;
  margin: 0px 10px 10px;
  width: 93%;
}
.hairline {
  padding: 0px 0px 10px;
  margin: 0px 0px 10px;
}
.margin_left {
  margin-left: 10px;
}
.closeBtn {
  position: absolute;
  top: 10px;
  right: 10px;
  color: #000 !important;
}
.cartItem {
  width: 90%;
  margin-left: 5%;
  margin-bottom: 15px;
  position: relative;
}
.leftdot {
  position: absolute;
  width: 6px;
  height: 6px;
  left: -3.5%;
  top: 15px;
  background: linear-gradient(to right, #ffc914, #ffc813);
  border-radius: 50%;
}
.cart_dish {
  width: 100%;
  overflow: hidden;
}
.cart_dish_name {
  width: 80%;
  height: 60px;
  line-height: 60px;
  text-indent: 5px;
}
.cart_dish_icon {
  display: flex;
  align-items: center;
}
.cart_dish_price {
  width: 20%;
  height: 35px;
  line-height: 35px;
  text-align: right;
  color: #aaa;
}
.cart_dish_des {
  width: calc(100% - 60px);
  height: 20px;
  line-height: 20px;
  font-size: 13px;
  color: #ccc;
}
.dish {
  display: flex;
}
.son_dish > .cart_dish_name {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
}
.son_dish > .cart_dish_price {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
}
.son_dish > .cart_dish_des {
  height: 18px;
  line-height: 18px;
  font-size: 12px;
}
.reduceBtn,
.addBtn {
  border-radius: 8px;
  padding: 5px;
}
.menuImg {
  border-radius: 10px;
  overflow: hidden;
}
.realPrice {
  color: #ff0000;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/newDishes.vue